export const RUNTIME_ENVIRONMENT = "production";
